import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPipe } from '../pipes/filtro.pipe';

import { VeiculoService } from '../services/veiculo.service';
import { ExcelService } from '../services/excel.service';
import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ModeloVeiculoService } from '../services/modelo-veiculo.service';
import { MarcaVeiculoService } from '../services/marca-veiculo.service';
@Component({
  selector: 'app-relatorio-veiculos',
  templateUrl: './relatorio-veiculos.component.html',
  styleUrls: ['./relatorio-veiculos.component.css'],
  animations: [loadingFade, modal, alert]
})
export class RelatorioVeiculosComponent implements OnInit {
  public loading = false;

  // paginacao
  public page = 1;
  public limit = 10;
  public count = 0;

  // alert
  public msg_alerta = '';
	public class_alerta = '';
	public flag_alerta = 'hidden';

  public veiculos = [];
  public clientes = [];
  public unidades = [];
  public modelosVeiculo = [];
  public marcasVeiculo = [];

  // filtro
	public filtro = [];
	public dadosFiltrados = [];
	public filtered = false;
	public formFiltro: FormGroup;
	public showFilter = true;
  public veiculos_array = [];

  constructor(
              private fb: FormBuilder,
              private authSvc: AuthService,
              private veiculoSvc: VeiculoService,
              private excelSvc: ExcelService,
              private clienteSvc: ClienteService,
              private unidadeSvc: UnidadeService,
              private modeloVeiculoSvc: ModeloVeiculoService,
              private marcaVeiculoSvc: MarcaVeiculoService,
              ) { }

  ngOnInit() {
	this.loading = true;  
		this.criaFiltro();
    this.pegaVeiculos(this.authSvc.getUsuarioId());
	this.loading = false;
  }

  criaFiltro() {
	  	this.loading = true;
		this.pegaClientes();
		this.pegaUnidades();
		this.pegaModelosVeiculo();
		this.pegaMarcasVeiculo();
		
		this.formFiltro = this.fb.group({
			cliente_id___cliente:null,
			unidade_id___veiculo:null,
			veiculo_id___veiculo:null,
			veiculo_placa___placa:null,
			marca_veiculo_id___veiculo:null,
			modelo_veiculo_id___veiculo:null
		});
		this.loading = false;
  }
  
  filtra() {
		//this.loading = true;
		this.filtro = this.formFiltro.value;
		console.log("filtro = ", this.filtro);
		this.dadosFiltrados = new FiltroPipe().transform(this.veiculos, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.page = 1;
		//this.loading = false;
	}

	pegaClientes(){
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.clientes = data;
		});
	}

	onChangeCliente(evento){
		this.formFiltro.controls.unidade_id___veiculo.setValue(null);
		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
			console.log(err);
		});
	}
	
	pegaUnidades(){
		this.unidadeSvc.getUnidadesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaModelosVeiculo(){
		this.modeloVeiculoSvc.getModelosVeiculo().then((data: any[])=> {
			this.modelosVeiculo = data;
		});
	}

	
	pegaMarcasVeiculo(){
		this.marcaVeiculoSvc.getMarcasVeiculo().then((data: any[])=> {
			this.marcasVeiculo = data;
		});
	}
	
	onChangeMarca(evento){
		this.formFiltro.controls.modelo_veiculo_id___veiculo.setValue(null);
		this.modeloVeiculoSvc.getModelosVeiculoByMarca(evento.marca_veiculo_id).then((data: any[])=> {
			this.modelosVeiculo = data;
		});
	}
	expandPanel(){
		this.showFilter = this.showFilter == true ? false: true;
	}

  pegaVeiculos(usuario_id) {
    this.veiculoSvc.getRelatorioVeiculos(usuario_id).then((data: any) => {
      this.veiculos = data;
      this.count = data.length;
    }).catch((err) => console.log(err));
  }

  primPagina() {
    this.page = 1;
  }

  paginaAnt() {
    this.page = Math.max(this.page - 1, 1);
  }

  proxPagina() {
    this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
  }

  ultPagina() {
    this.page = Math.ceil(this.count / this.limit);
  }

  exportarExcel(){
		let data = [];
		if(this.dadosFiltrados.length == 0){
			this.dadosFiltrados = this.veiculos;
		}
		for(let index in this.dadosFiltrados){
			data[index] = {
		'Central' : this.dadosFiltrados[index].cliente.cliente_nome,
		'Unidade' : this.dadosFiltrados[index].unidade.unidade_nome,
		'Tipo de Veículo' : this.dadosFiltrados[index].tipo.tipo_veiculo_nome,
		'Veiculo' : this.dadosFiltrados[index].veiculo_numero,
		'Placa' : this.dadosFiltrados[index].veiculo_placa,
		'Fabricante' : this.dadosFiltrados[index].marca.marca_veiculo_nome,
		'Modelo' : this.dadosFiltrados[index].modelo.modelo_veiculo_nome,
		'Ano do Veículo' : this.dadosFiltrados[index].modelo.veiculo_ano_modelo,
		'Km' : this.dadosFiltrados[index].quilometragem,
		'Seguro' : this.dadosFiltrados[index].seguro,
		'Combustível' : this.dadosFiltrados[index].combustivel,
		'Multas' : this.dadosFiltrados[index].multas,
		'Peças' : this.dadosFiltrados[index].manutencao
			};
		}
		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Relatório de veículos');
  }
  
  print(){
		let url = location.href.split('#')[0] + '#' +'(print:print/relatorio/veiculos/'+ this.authSvc.getUsuarioId() +')'
		window.open(url);
	}

	clickLimparCampos(){
		this.formFiltro = this.fb.group({
			cliente_id___cliente:null,
			unidade_id___veiculo:null,
			veiculo_id___veiculo:null,
			veiculo_placa___placa:null,
			marca_veiculo_id___veiculo:null,
			modelo_veiculo_id___veiculo:null
		});
    }      

}
